import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: FertilizerCreateInput!
  ) {
    createOneFertilizer(data: $data) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fertilizante criado`, mutationTypes.CREATE)
)
